<template>
  <div class="category-tutorial">
    <div v-if="!props.isSingle" class="group__title flex items-center justify-between">
      <h2 class="title m-0">
        <span class="mr-[12px]">{{ category.title }}</span>
        <span class="text-14 text-[var(--text-1-60)] font-[400]">
          {{ $t('ke-cheng-shu-liang') }}:
          <b class="text-[var(--purple-6)] font-[600]">
            {{ props.category.guide_video_info?.length || 0 }}
          </b>
          {{ $t('jie-ke') }}
        </span>
      </h2>
      <span
        v-if="category.collapse"
        type="text"
        class="more-btn flex justify-center items-center cursor-pointer"
        aria-label="go academy detail"
        @click="$emit('onMore')"
      >
        {{ $t('cha-kan-geng-duo') }}
        <iconpark-icon name="arrowright" size="16"></iconpark-icon>
      </span>
    </div>
    <div class="group__content">
      <ContentClassCard
        v-for="card in displayList"
        :key="card.id"
        :url="card.cover_url"
        :isNew="card.is_new || card.guide_video_info?.[0]?.is_new"
        :link="{
          name: PageKey.TUTORIAL_INFO,
          params: {
            id: card?.guide_video_info ? card.guide_video_info?.[0].id : card?.id,
          },
        }"
        :video="card?.guide_video_info ? card.guide_video_info?.[0].video_url : card?.video_url"
        class="cursor-pointer"
        @click="handleCardClick(card)"
      >
      </ContentClassCard>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { PageKey } from '~/constants/page';
import type { IGuidVideo, ISeriesClass } from '~/api/interface/class';

const props = defineProps<{
  category: ISeriesClass;
  isAcademy: boolean;
  isSingle: boolean;
}>();

const displayList = computed(() => {
  const list = props.category.guide_video_info || [];

  if (props.isSingle) {
    return list;
  }

  return props.category.collapse ? list.slice(0, 4) : list;
});

const handleCardClick = (source: ISeriesClass | IGuidVideo) => {
  navigateTo({
    name: PageKey.TUTORIAL_INFO,
    params: { id: source.id },
  });
};
</script>

<style lang="scss" scoped>
.group {
  &__title {
    margin-bottom: 16px;
    h2 {
      font-size: 18px;
      line-height: 1.4;
      color: var(--text-1);
    }
    .more-btn {
      font-size: 14px;
      line-height: 1;
      color: var(--text-1);
      opacity: 0.6;
      &:hover {
        opacity: 0.9;
      }
    }
  }
  &__content {
    display: grid;
    grid-template-columns: repeat(4, minmax(56px, 1fr));
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-auto-rows: 162px;
    grid-auto-flow: dense;
    gap: 28px 16px;
  }
}
</style>
